const PropTypes = require('prop-types');

const React = require('react');
import { connect } from 'react-redux';

const { FormattedText, formatText } = require('core/i18n').i18n;
const moment = require('moment');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
import { formatDate } from 'utilities/dateHelper';
// @ actions
import {
    initDateFilter,
    setDateFilter,
    setFromDateFilter,
    setToDateFilter
} from 'actions/filters'

//@constants
const {
    DATE_FILTER_ANNUAL,
    DATE_FILTER_BIANNUAL,
    DATE_FILTER_CUSTOM,
    DATE_FILTER_FORTNIGHTLY,
    DATE_FILTER_THREE_MONTHS,
    DATE_FILTER_MONTHLY,
    DATE_FILTER_NONE,
    DATE_FILTER_TWO_YEARS
} = require('constants/index');
const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');
class DateFilter extends React.PureComponent {
    constructor(props) {
        super(props);

        this.setLocals();

        this.state = {
            standardDateFilters: this.createStandardDateFilters()
        };
    }

    componentDidMount() {
        const {
            filtersId,
            filterId,
            filterType,
            immFilter,
            initDateFilter,
            initialSelected,
            isTaggable,
        } = this.props;
        !immFilter && initDateFilter(filtersId, filterId, false, initialSelected, filterType, null, null, isTaggable);
    }

    checkActive = (from, to) => {
        return !!from && !!to;
    }

    setFromFilterChange = (from) => {
        const {
            filtersId,
            filterId,
            immFilter,
            setFromDateFilter,
        } = this.props;
        setFromDateFilter(filtersId, filterId, this.checkActive(from, immFilter.get('to')), from);
    }

    setToFilterChange = (to) => {
        const {
            filtersId,
            filterId,
            immFilter,
            setToDateFilter,
        } = this.props;
        setToDateFilter(filtersId, filterId, this.checkActive(to, immFilter.get('from')), to);
    }

    handleStandardFilterChange = (filterName) => {
        const {
            filtersId,
            filterId,
            setDateFilter,
        } = this.props;
        const { standardDateFilters } = this.state;
        const { from, to } = standardDateFilters.find(dateFilter => dateFilter.filterName == filterName);

        setDateFilter(
            filtersId,
            filterId,
            this.checkActive(from, to),
            filterName,
            from,
            to
        );
    }

    setLocals() {
        const language = moment().locale()

        const getMonthsShort = () => {
            const monthsShort = {
                'pt': ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"]
            };
            return monthsShort[language];
        }

        if (language === 'pt') {
            moment.updateLocale(language, {
                monthsShort: getMonthsShort()
            });
        }

    }

    renderCustomDateFilter() {
        const { immFilter, minDate } = this.props;
        const today = moment().startOf('day')

        return (
            immFilter && immFilter.get('selected') == DATE_FILTER_CUSTOM &&
                <div className="row date-filter__custom-ranges">
                    <div className="col-xs-6">
                        <div className="date-filter__label-to">
                            <FormattedText value="filterDate-fromRange" />
                        </div>
                        <DatePickerCustom
                            callback={this.setFromFilterChange}
                            minDate={minDate}
                            maxDate={immFilter.get('to') || today}
                            selectedDate={immFilter.get('from') || today}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                    <div className="col-xs-6">
                        <div className="date-filter__label-from">
                            <FormattedText value="filterDate-toRange" />
                        </div>
                        <DatePickerCustom
                            callback={this.setToFilterChange}
                            minDate={immFilter.get('from') || today}
                            maxDate={today}
                            selectedDate={immFilter.get('to') || today}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            innerSmallContainer
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
        );
    }

    renderLabel = (dateFilter) => {
        return (
            <div className="date-filter__radio-label">
                <span className="date-filter__radio-label-primary">
                    { formatText(`filterDate-label${dateFilter.filterName}`) }
                </span>
                {
                    dateFilter.subLabel &&
                        <span className="date-filter__radio-label-secondary">
                            {
                                ' - ' + formatText('filterDate-range', [
                                    formatDate(dateFilter.from, formatText('filterDateAhead-rangeFormat')),
                                    formatDate(dateFilter.to, formatText('filterDateAhead-rangeFormat'))
                                ])
                            }
                        </span>
                }
            </div>
        )
    }

    renderDateFilters = () => {
        const { standardDateFilters } = this.state;
        return standardDateFilters.map((dateFilter, index) => {
            return (
                <RadioButton
                    key={index}
                    className="date-filter__radio-option"
                    label={this.renderLabel(dateFilter)}
                    value={dateFilter.filterName}
                />
            );
        })
    }

    createStandardDateFilters = () => {
        const {
            showFortnightly,
            showMonthly,
            showBiannual,
            showAnnual,
            showTwoYears,
            showThreeMonths
        } = this.props;
        const today = moment().startOf('day');
        return [
            {
                filterName: DATE_FILTER_NONE,
                subLabel: false,
                from: moment().startOf('day').subtract('1', 'years'),
                to: today
            },
            ...(showFortnightly ? [{
                filterName: DATE_FILTER_FORTNIGHTLY,
                subLabel: true,
                from: moment().startOf('day').subtract('2', 'weeks'),
                to: today
            }] : []),
            ...(showMonthly ? [{
                filterName: DATE_FILTER_MONTHLY,
                subLabel: true,
                from: moment().startOf('day').subtract('1', 'months'),
                to: today
            }] : []),
            ...(showBiannual ? [{
                filterName: DATE_FILTER_THREE_MONTHS,
                subLabel: true,
                from: moment().startOf('day').subtract('3', 'months'),
                to: today
            }] : []),
            ...(showAnnual ? [{
                filterName: DATE_FILTER_BIANNUAL,
                subLabel: true,
                from: moment().startOf('day').subtract('6', 'months'),
                to: today
            }] : []),
            ...(showTwoYears ? [{
                filterName: DATE_FILTER_ANNUAL,
                subLabel: true,
                from: moment().startOf('day').subtract('1', 'years'),
                to: today
            }] : []),
            ...(showThreeMonths ? [{
                filterName: DATE_FILTER_TWO_YEARS,
                subLabel: true,
                from: moment().startOf('day').subtract('2', 'years'),
                to: today
            }] : []),
            {
                filterName: DATE_FILTER_CUSTOM,
                subLabel: false,
                from: today,
                to: today
            }
        ]
    }

    render() {
        const { immFilter } = this.props;
        if (immFilter) {
            return (
                <div>
                    <RadioButtonGroup
                        name="date-filter"
                        idPrefix="date-filter-radio"
                        selectedValue={immFilter.get('selected')}
                        onChange={this.handleStandardFilterChange}
                        className="date-filter__options"
                    >
                        { this.renderDateFilters() }
                    </RadioButtonGroup>
                    { this.renderCustomDateFilter() }
                </div>
            )
        } else {
            return null;
        }
    }
}

DateFilter.propTypes = {
    filtersId: PropTypes.string.isRequired,
    filterId: PropTypes.string.isRequired,
    filterType: PropTypes.string,
    initDateFilter: PropTypes.func.isRequired,
    selected: PropTypes.string,
    setDateFilter: PropTypes.func.isRequired,
    setFromDateFilter: PropTypes.func.isRequired,
    setToDateFilter: PropTypes.func.isRequired,
    immFilter: PropTypes.object,
    initialSelected: PropTypes.string,
    isTaggable: PropTypes.bool,
    minDate: PropTypes.object,
    showYearDropdown: PropTypes.bool,
    showAnnual: PropTypes.bool,
    showBiannual: PropTypes.bool,
    showFortnightly: PropTypes.bool,
    showMonthly: PropTypes.bool,
    showTwoYears: PropTypes.bool,
    showThreeMonths: PropTypes.bool
};

DateFilter.defaultProps = {
    filterType: 'dateFilter',
    initialSelected: DATE_FILTER_NONE,
    isTaggable: true,
    minDate: moment('2005-01-01').startOf('day'),
    showYearDropdown: true,
    showAnnual: true,
    showBiannual: true,
    showFortnightly: true,
    showThreeMonths: false,
    showMonthly: true,
    showTwoYears: false
};

export default connect(
    null,
    {
        initDateFilter,
        setDateFilter,
        setFromDateFilter,
        setToDateFilter
    }
)(DateFilter);
